const FSMCONSTANTS = {
  COLORS: 'colors',
  COLOUR: 'Colour',
  SERVICE_AGE: 'Service Age',
  TAGS: 'Tags',
  DASHBOARD: 'DASHBOARD',
  SUBTARGET_VIEW: 'SUBTARGET_VIEW',
  REPORTEE_VIEW: 'REPORTEE_VIEW',
  SELF_VIEW: 'SELF_VIEW',
  TEAM_VIEW: 'TEAM_VIEW',
  SELF_TRACKING: 'SELF_TRACKING',
  TEAM_TRACKING: 'TEAM_TRACKING',
  SUBTEAM_TRACKING: 'SUBTEAM_TRACKING',
  TARGET: 'TARGET',
  MY_TARGETS: 'My Targets',
  TEAM_TARGETS: 'Team Target',
  MERCHANT_MAP: 'MERCHANT_MAP',
  LANDING_PAGE: 'LANDING_PAGE',
  BEAT_CLOSURE: 'beatClosure',
  GENERATE_OTP_PAGE: 'GENERATE_OTP_PAGE',
  ZONE_LIST_VIEW: 'ZONE_LIST_VIEW',
  FILTER_MODAL: 'filter modal',
  MERCHANT_LIST_MODAL: 'merchant list',
  MERCHANT_CARD: 'merchant card',
  SERVICE_HEADER_MODAL: 'SERVICE_HEADER_MODAL',
  SEARCH_MODAL: 'SEARCH_MODAL',
  LIST_DETAILING: 'LIST_DETAILING',
  ADD_TASK: 'ADD_TASK',
  ATTENDANCE: 'ATTENDANCE',
  REQUEST: 'REQUEST',
  LEAVE_MANAGEMENT: 'LEAVEMANAGEMENT',
  HOLIDAY_CALENDAR: 'HOLIDAYCALENDAR',
  CALENDAR: 'CALENDAR',
  LOCATION_401: 'You are using fake location.',
  LOCATION_402: 'Location on is mandatory.',
  LOCATION_GENERIC_ERROR: 'Unable to fetch location.',
  NETWORK_AVAILABLE: 'NETWORK_AVAILABLE',
  NETWORK_NOT_AVAILABLE: 'NETWORK_NOT_AVAILABLE',
  GENERIC_ERROR: 'GENERIC_ERROR',
  GENERIC_MODAL: 'GENERIC_MODAL',
  TIMEOUT_ERROR: 'Oops, something went wrong! Please try again.',
  AUTHORIZE_ERROR: 'Oops, Unable to authorize user.',
  ACCESS_TOKEN_ERROR: 'Oops, Unable to fetch access token.',
  LANDING_PAGE_FAILURE_ERROR:
    'Oops, Unable to fetch data from PSA app! Please try again.',
  SAVE_VMN_DETAILS: 'Selected Team`s VMN Details have been saved successfully.',
  NO_DATA_AVAILABLE: 'No data Available.',
  EMPTY_PRIORITY_ORDER: 'Sequence order can`t be empty.',
  NON_POSITIVE_PRIORITY_ORDER: 'Sequence order should be positive.',
  EMPTY_NAME_FIELD: 'Name Field can`t be empty.',
  EMPTY_DB_FIELD: 'Db Name Field can`t be empty.',
  EMPTY_COLUMN_FIELD: 'Column Field can`t be empty.',
  FSE_SPECIFIC_MODAL: 'FSE_SPECIFIC_MODAL',
  ATTENDANCE_RECORDS: 'ATTENDANCE_RECORDS',
  LOCATION_404: 'Location not received.',
  PROFILE: 'PROFILE',
  CONFIRM_TL_PRESENCE: 'Are you with TL?',
  GATE_MEETING_CHECKIN_SUCCESSFUL: 'You have checked in successfully!',
  GATE_MEETING_CHECKIN_DISTANCE_ERROR:
    "You are far away from the gate meeting location! Check in once you're at the gate meeting location.",
  GATE_MEETING_POPUP_BUTTON_TEXT: 'Okay, Got it!',
  ALREADY_CHECKED_IN_ERROR:
    "You have already checked in for today's Gate Meeting!",
  GATE_MEETING_NOT_FOUND: 'GATE_MEETING_NOT_FOUND',
  GATE_MEETING_LOCATION_INACCURATE: 'GATE_MEETING_LOCATION_INACCURATE',
  GATE_MEETING_NOT_FOUND_ERROR_MESSAGE: 'No active meeting is going on.',
  GATE_MEETING_PROXIMITY_FAILURE: 'GATE_MEETING_PROXIMITY_FAILURE',
  GATE_MEETING_PROXIMITY_FAILURE_ERROR_CODE: 'FSE-4460',
  GATE_MEETING_NOT_FOUND_ERROR_CODE: 'FSE-4462',
  GATE_MEETING_LOCATION_FETCH_ERROR_CODE: 'FSE-4466',
  GATE_MEETING_ENDED_ERROR_CODE: 'FSE-4387',
  GATE_MEETING_ENDED_ERROR: 'GATE_MEETING_ENDED_ERROR',
  ATTENDANCE_ALREADY_MARKED: 'ATTENDANCE_ALREADY_MARKED',
  ATTENDANCE_ALREADY_MARKED_ERROR_CODE: 'FSE-4463',
  TL_NOT_IN_ZONE_ERROR_CODE: 'AMS-482',
  TL_NOT_IN_ZONE_ERROR: 'TL_NOT_IN_ZONE_ERROR',
  TL_NOT_IN_ZONE_ERROR_TEXT: 'You are not in zone. Cannot start gate meeting!',
  MEETING_ALREADY_ACTIVE_ERROR_CODE: 'FSE-4386',
  MEETING_ALREADY_ACTIVE_ERROR: 'MEETING_ALREADY_ACTIVE_ERROR',
  MEETING_ALREADY_ACTIVE_ERROR_TEXT: 'Gate Meeting is already active!',
  UNABLE_TO_START_GATE_MEETING: 'Unable to Start Gate Meeting',
  USER_NOT_A_TL_ERROR_CODE: 'FSE-4385',
  IMAGE_ALREADY_UPLOADED_ERROR_CODE: 'FSE-4388',
  IMAGE_ALREADY_UPLOADED: 'IMAGE_ALREADY_UPLOADED',
  IMAGE_ALREADY_UPLOADED_ERROR_TEXT: 'Image is already uploaded.',
  IMAGE_UPLOAD_DEFAULT_ERROR_TEXT: 'Unable to Upload Gate Meeting Image',
  GATE_MEETING_ALREADY_ENDED_ERROR_CODE: 'FSE-4387',
  GATE_MEETING_ALREADY_ENDED: 'GATE_MEETING_ALREADY_ENDED',
  GATE_MEETING_ALREADY_ENDED_ERROR_TEXT: 'No active gate meeting is going on.',
  GATE_MEETING_IMAGE_UPLOAD_SUCCESSFUL:
    'Gate Meeting image uploaded successfully!',
  GATE_MEETING_START_SUCCESS: 'GATE_MEETING_START_SUCCESS',
  GATE_MEETING_IMAGE_UPLOAD_SUCCESS: 'GATE_MEETING_IMAGE_UPLOAD_SUCCESS',
  GATE_MEETING_END_SUCCESS: 'Gate Meeting Ended Successfully!',
  GATE_MEETING_END_ERROR: 'Error while Ending Gate Meeting',
  IMAGE_NOT_CLICKED_IN_LOCATION_ERROR_CODE: 'FSE-4464',
  IMAGE_NOT_CLICKED_IN_LOCATION: 'IMAGE_NOT_CLICKED_IN_LOCATION',
  IMAGE_NOT_CLICKED_IN_LOCATION_ERROR_TEXT:
    'You are not present at the gate meeting location.',
  FETCHING_COORDINATES: 'Fetching your current location, please wait',
  IMAGE_NOT_UPLOADED_ERROR_CODE: 'FSE-4394',
  IMAGE_NOT_UPLOADED: 'IMAGE_NOT_UPLOADED',
  INACTIVE_GATE_MEETING: 'INACTIVE_GATE_MEETING',
  CONFIRM_MEETING_START_MODAL_TEXT:
    'The Gate meeting will start at this location. Please ensure all FSEs join the gate meeting at this location. You will be able to end the Gate meeting in this location only.',
  INVALID_PAYLOAD: 'INVALID_PAYLOAD',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  REFRESH: 'Refresh',
  REFRESH_ERROR_MESSAGE:
    'Unable to fetch your location at the moment! Please refresh',
  MAX_REFRESH_ERROR_MESSAGE:
    'Unable to fetch your location accurately at the moment! Please close the app and try again.',
  START_MEETING: 'START MEETING',
  END_MEETING: 'END MEETING',
  TITLE_FOR_GATE_MEETING: 'Title for the Gate Meeting',
  ERROR_MSG_FOR_TITLE_GATE_MEETING:
    'Please enter a valid title for gate meeting',
  JOIN_MEETING: 'JOIN MEETING',
  JOINED_MEETING: 'JOINED',
  GATE_MEETING_DEFAULT_MEETING_PLACEHOLDER: 'Meet-up with your FSEs',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  MEETING_OUT_OF_RANGE: 'MEETING_OUT_OF_RANGE',
  MEETING_OUT_OF_RANGE_ERROR_CODE: 'FSE-4464',
  ZONE_INFO: 'ZONE_INFO',
  USER_PROFILE: 'USER_PROFILE',
  MY_MERCHANTS: 'My Merchants',
  TEAM_MERCHANTS: 'Team Merchants',
  COMP_MERCHANT: 'Competitor Merchant',
  SEARCHED_TRACKING: 'SEARCHED_TRACKING',
  PATH_TRACKING: 'PATH_TRACKING',
  MERCHANT_SEARCH: 'MERCHANT_SEARCH',
  MERCHANT_VIEW_ZONE: 'MERCHANT_VIEW_ZONE',
  GATE_MEETING: 'GATE_MEETING',
  GATE_MEETING_NOTIF: 'GATE_MEETING_NOTIF',
  CREATE_NEW_GATE_MEETING: 'CREATE_NEW_GATE_MEETING',
  P4B: 'p4b',
  USER_CALENDAR: 'USER_CALENDAR',
  MAP_LOAD_ERROR:
    'Oops, something went wrong! Please try loading this map again.',
  USER: 'USER',
  GEOHASH_SEARCH: 'GEOHASH_SEARCH',
  LOCATION_CACHE_TIME: 30, // seconds
  DESIGNATIONMAP: {
    BUSINESSHEAD: 'businesshead',
    HUBHEAD: 'hubhead',
    REGIONALHEAD: 'regionalhead',
    STATEHEAD: 'statehead',
    CITYHEAD: 'cityhead',
    ASM: 'asm',
    TL: 'tl',
    KAM: 'kam',
    FSE: 'fse',
  },
  ICONCONFIG: {
    businesshead: '/images/BusinessHead.svg',
    hubhead: '/images/HubHead.svg',
    regionalhead: '/images/regional_Head.svg',
    statehead: '/images/StateHead.svg',
    cityhead: '/images/CityHead.svg',
    asm: '/images/Asm.svg',
    tl: '/images/FSM_TL.svg',
    kam: '/images/Kam.svg',
    fse: '/images/fse-icon.svg',
    'sr.fse': '/images/Sr.Fse.svg',
    groupleader: '/images/GroupLeader.svg',
  },
  Event_Designation: {
    'Business Head': 'BH',
    'Hub Head': 'HH',
    'Regional Head': 'RH',
    'State Head': 'SH',
    'City Head': 'CH',
    ASM: 'ASM',
    TL: 'TL',
    FSE: 'FSE',
    PSA: 'PSA',
  },
  CREATE_NEW: 'Create New',
  NO_GATE_MEETING: 'You have not created any gate meeting.',
  SETTLEMENT_SUMMARY: 'SETTLEMENT_SUMMARY',
  SETTLEMENT_SUMMARY_HEADING: 'Transactions',
  PSA: 'PSA',
  PSA_PENALTY: 'PSA_PENALTY',
  PSA_EARNINGS: 'PSA_EARNINGS',
  PSA_SETTLED_AMOUNT: 'Amount settled to',
  PSA_UNSETTLED_AMOUNT: 'Amount will settle to',
  MY_ZONE: 'MY_ZONE',
  ZONE_POP_UP: 'ZONE_POP_UP',
  PSA_OPPORTUNITY: 'PSA_OPPORTUNITY',
  EDIT_ZONE_MODE: 'EDIT_ZONE_MODE',
  FSM_GG_APP: 'FSM_GG_APP',
  FSM_P4B_Attendance: 'FSM_P4B_Attendance',
  ASSIGN_FSE: 'ASSIGN_FSE',
  EDIT_TASK: 'EDIT_TASK',
  MERCHANT_DETAIL: 'MERCHANT_DETAIL',
  '3P_FSE': '3P_FSE',
  PSA_TEAM: 'PSA Team',
  SEMI_ORG_OFFLINE_CHANNEL: 'Semi Organized Offline Channel',
  QR: 'QR',
  GG_HOME_PAGE: 'GG_HOME_PAGE',
  FSM_PAGE: 'FSM_PAGE',
  ZONE_LIST_FILTER_TYPE: 'zoneList',
  MERCHANT_MAP_FILTER_TYPE: 'merchantMap',
  PLOT_MERCHANT: 'PLOT_MERCHANT',
  ACCEPT: 'Accept',
  REJECT: 'Reject',
  URGENT: 'Urgent',
  SERVICE_FLOW: 'SERVICE_FLOW',
  ALL: 'All',
  UNCLAIMED: 'unclaimed',
  CLOSED: 'closed',
  EDC_SERVICE_TEAM: 'edc service team',
  URGENT_BEAT_ENABLED_TEAM: [
    'edc service team',
    'offline payments service team',
  ],
  MY_EARNINGS: 'MY_EARNINGS',
  EARNINGS_DASHBOARD: 'EARNINGS_DASHBOARD',
  FILTER_PANEL: 'FILTER_PANEL',
  SEARCH_PANEL: 'SEARCH_PANEL',
  SERVICE_FLOW_LIST: 'SERVICE_FLOW_LIST',
  ASSIGN_REASSIGN_REQUEST: 'ASSIGN_REASSIGN_REQUEST',
  ASSIGN_TO_TL: 'ASSIGN_TO_TL',
  ASSIGN_REASSIGN_REQUEST_SEARCH_AGENT: 'ASSIGN_REASSIGN_REQUEST_SEARCH_AGENT',
  SERVICE_FLOW_MAP: 'SERVICE_FLOW_MAP',
  SERVICE_FLOW_FACING_ISSUE: 'SERVICE_FLOW_FACING_ISSUE',
  RESCHEDULE_REQUEST: 'RESCHEDULE_REQUEST',
  GATE_MEETING_TEAM_SUBTEAM: {
    'semi-organised qr': [],
  },
  CLOUDTELEPHONY_WHITELIST: [
    'soundbox-device service',
    'edc retail service team-device service',
  ],
  PHONE_NUMBER_NOT_FOUND: 'Phone number not found.',
  MID_NOT_FOUND: 'MID not found.',
  SLA_BREACH: 'SLA_OVER', // Keeping this static as getting this very value from Notification
  UNAUTHORIZED: 'Unauthorized',
  EMPTY_DEPARTMENT_FIELD: 'Fields can`t be empty',
  SAVE_WHITELIST_DETAILS: 'New Added Field data have been saved successfully.',
  DUPLICATE_FIELD: "Fields can't be duplicate",
  OTHER_ISSUES: 'OTHER_ISSUES',
  HAPPYCODE_PENDING: 'HAPPYCODE_PENDING',
  NOT_SERVICEABLE: 'NOT_SERVICEABLE',
  TIMED_OUT: 'TIMED_OUT',
  EDIT_ADDRESS: 'EDIT_ADDRESS',
  DESIGNATION: {
    'Business Head': 'BH',
    'Hub Head': 'HH',
    'Regional Head': 'RH',
    'State Head': 'SH',
    'City Head': 'CH',
    ASM: 'ASM',
    TL: 'TL',
    FSE: 'FSE',
    PSA: 'PSA',
    PAM: 'PAM',
  },
  UNASSIGNED_FSE: 'Unassigned FSE',
  ASSIGNED_FSE: 'Assigned FSE',
  UNASSIGNED_ZONE: 'Unassigned Zone',
  ASSIGNED_ZONE: 'Assigned zones',
  BEAT_MERCHANTS: 'Number of Beat Merchants currently assigned',
  DONE: 'Done',
  MY_ZONES: 'My Zones',
  ZONE_TYPE: 'Zone Type:',
  ZONE_CLASS: 'Zone Class:',
  TOTAL_STORIES: 'Total Stores :',
  VIEW_EDIT: ' View / Edit Assignment',
  VIEW: ' View Assignment',
  TOTAL: 'Total ',
  TO_BE_ASSIGNED: ' To be Assigned',
  TO_BE_REMOVED: ' To be Removed',
  LOW_PRIORITY: 'Low Priority',
  HIGH_PRIORITY: 'High Priority',
  ADD_ANOTHER_FIELD: 'Add Another Field',
  SAVE: 'Save',
  SELECT: 'select',
  DUPLICATE_MESSAGE: 'can`t be duplicate.',
  SEQUENCE_ORDER: 'Sequence order',
  PRIORITY: 'Priority',
  SHOW_MERCHANT_LIST: 'Show Merchant List',
  FILTERED_SHOW_MERCHANT_LIST: 'Show Merchant List (Filtered View)',
  FSM_PANEL: 'fsm_panel',
  EMPTY_STRING: '',
  CIF_ACCESS_ALERT: 'You do not have permission to access FSE Admin Dashboard',
  PERMISSIONS_FAILURES: 'PERMISSIONS_FAILURES',
  SESSION_EXPIRED: 'Your session has expired.',
  NETWORK_ERROR:
    'Your internet connection appears to be slow or disconnected, please check and try again.',
  BANK_ERROR_CODE: 'FSE-533',
  COLOR_FILTER_ERROR_CODE: 'FSE-613',
  MOBILE: 'mobile',
  SEARCH: 'Search',
  ENTER_TEN_DIGIT_MOBILE_NUMBER: 'Enter 10 digit mobile number',
  SALES_REQUESTS: 'Sales Requests',
  HEADER_REQUEST_TYPE: 'headerRequestType',
  UAC: 'uac',
  UAC_HEADER: 'Shop address captured',
  UAC_SUBHEADER: `Merchant's shop address details have been captured successfully. The same will be updated shortly.`,
  SELECT_ADDRESS: 'Select Address',
  SUBMIT_ADDRESS: 'Submit Address',
  CITY: 'City',
  SHOP_NO: 'Shop Number or Name',
  NEARBY_LANDMARK_OR_DIRECTIONS_TO_REACH:
    'Nearby Landmark or Directions to Reach',
  EXIT_MANAGEMENT: 'exitManagement',
  INITIATE_RESIGNATION: 'initiateResignation',
  INVENTORY_RETURN: 'inventoryReturn',
  NO_INVENTORY: 'NoInventoryInHandPage',
  EMPID_SUCCESS_MSG: 'Emp Id submitted successfully.',
  DEVELOPMENT: 'development',
  EXIT_DETAILS_API_SUCCESS: 'Successfully fetched exit details data',
  EXIT_DETAILS_API_FAILURE: 'Error in fetching exit details data',
  EXIT_DETAILS_API_WITH_PARAMS_SUCCESS:
    'Successfully fetched exit details data call via notification',
  EXIT_DETAILS_API_WITH_PARAMS_FAILURE:
    'Error in fetching exit details data call via notification',
  RESIGN_API_SUCCESS: 'Successfully resigned',
  RESIGN_API_WRONG_RESIGNATION_DATE_FORMAT: 'Wrong resignation date format',
  RESIGN_API_LAST_WORKING_DATE_ISSUE:
    'Last working day is of wrong date format or missing',
  RESIGN_API_EXIT_REASON_MISSING: 'Exit reason is blank or missing',
  RESIGN_API_EXIT_REQUEST_CANNOT_RAISE_FOR_OTHERS:
    'Exit request cannot be raised for other employee',
  RESIGN_API_EXIT_REQUEST_ALREADY_EXIST:
    'An active exit process already exists for this employee',
  SEPARATION_REASONS_SUCCESS: 'separating reason successfully populated',
  SEPARATION_REASONS_FAILURE: 'not able to populate separating reason',
  PENDING_DUES_SUCCESS: 'Successfully got pending dues',
  PENDING_DUES_FAILURE:
    'User Info does not exist for Cust ID obtained from uid or Session Token',
  HIERARCHY_SUCCESS: 'HIERARCHY_SUCCESS',
  HIERARCHY_NOT_VALID_TYPE: 'Please enter valid type.',
  HIERARCHY_OFFSET_NULL: 'Offset can not be null.',
  HIERARCHY_LIMIT_NULL: 'Limit can not be null.',
  HIERARCHY_PROFILE_DO_NOT_EXIST: 'User Profile Does Not exist',
  SUCCESS: 'Success!',
  REMARK_MSG: 'Remark Updated Successfully!',
  REMARK_REASON: 'Reason entered Successfully!',
  SUBMIT: 'Submit',
  UPDATE_REMARK: 'Update Remark',
  NO_UNMAP_CAPACITY: 'No Unmap Capacity',
  ERROR: 'Error!',
  UNMAP_CAPACITY_MSG1: "This FSE doesn't have unmap capacity, select upto ",
  UNMAP_CAPACITY_MSG2: ' beats for assignment',
  NO_LIMIT_UNMAP_CAPACITY: 'No Limit For Unmap Capacity',
  REJECT_APPLICATION: 'Reject Application',
  SEND_TO_MHD: 'Send to MHD',
  MHD_POP_UP_MSG:
    'Hope you have called the merchant. This request will be forwarded to Merchant Help Desk (MHD)',
  MHD_POP_UP_MSG_FOR_CPV:
    'Hope you have called the applicant. This request will be forwarded to the QC team.',
  TASK_DEACTIVATED: 'Task deactivated successfully!!',
};

export const analyticsEventScreenName = {
  NAVIGATION_APP_NOT_FOUND: 'No navigation app found.',
  VIEW_ON_TARGET_PAGE: 'Number of views on my targets page',
  VIEW_ON_TARGET_PAGE_FOR_ACTIVE_FILTER:
    'Number of views on my targets page on active filter',
  VIEW_ON_TARGET_PAGE_FOR_LAST_MONTH_FILTER:
    'Number of views on my targets page on last month filter',
  VIEW_ON_TARGET_PAGE_FOR_LAST_THREE_MONTH_FILTER:
    'Number of views on my targets page on last 3 month filter',
  VIEW_ON_TARGET_PAGE_FOR_LAST_SIX_MONTH_FILTER:
    'Number of views on my targets page on last 6 month filter',
  VIEW_ON_TARGET_PAGE_FOR_LAST_ONE_YEAR_FILTER:
    'Number of views on my targets page on last 1 year filter',
  USER_ON_ACTIVE_PAGE: 'Number of users landing on activity page',
  USER_ON_TEAM_TRACKING: 'Number of users clicking on team tracking',
  USER_ON_PROFILE_PAGE: 'Number of users landing on profile page',
  NUMBER_OF_PROFILE_CLICK: 'Number of profile clicks',
  USER_ON_LANDING_PAGE_ROLE_WISE:
    'Number of users landing on FSM landing page role wise',
  SEARCHES_ON_MERCHANT_PAGE_HIERACHY_WISE:
    'Number of searches on my merchant page (hierachy level wise)',
  MY_TEAM: 'My Team',
  MY_TEAM_ZONE_MAP: 'My Team Zones Map',
  MY_MERCHANTS_MAP: 'My Merchants Map',
  TEAM_MERCHANTS_MAP: 'Team Merchants Map',
  TEAM_MERCHANT_LIST_VIEW: 'Team Merchants List view',
  ZONE_LIST_VIEW: 'Zone List View',
  MY_ZONE_ASSIGNMENT: 'My Zone Assignment',
  MY_ZONE_MAP: 'My Zones Map',
  MERCHANT_DETAIL: 'Merchant Details',
  ASSIGN_AGENT: 'Assign Agent',
  TEAM_MERCHANT: 'Team Merchants',
  VIEW_LOCATION_HISTORY: 'View Location History',
  ATTENDANCE_CAMERA: 'Attendance Camera',
  FSM_HOME_PAGE: 'FSM Homepage',
  TRACK_YOUR_TEAM: 'Track Your Team',
  REQUEST_LEAVE_PAGE: 'Request leave page',
  SUBTEAM_TRACKING: 'SubTeam Tracking',
  SERVICE_FLOW_LIST: 'Service Flow List View',
  SERVICE_FLOW_MAP: 'Service Flow Map view',
  PROFILE_SCREEN: 'profile screen',
  FILTER_PANEL: 'Service Flow Filter Panel',
  SEARCH_PANEL: 'Service Flow Search Panel',
  MY_ATTENDANCE: 'My Attendance',
  SELF_TRACKING: 'FSE Self Tracking',
  CALLING_COMPONENT: 'Calling Component',
  TEAM_RESIGNATION: 'Team Resignation',
  FSE_RESIGNATION: 'FSE Resignation',
  TL_RESIGNATION: 'TL Resignation',
  EXIT_MANAGEMENT: 'Exit Management',
  TL_VIEWING_FSE_INVENTORY_DETAILS: 'TL viewing Fse Inventory Details',
};

export const pathConstantKeys = {
  CIF: '/cif',
  LOGIN: '/login',
  PERMISSION_DENIED: '/permissionsDenied',
  ERROR_FALLBACK: '/errorFallback',
  FSM: '/fsm',
  BASE: '/base',
  INDEX_HTML: '/index.html',
  FAIR_DAY: '/fairday',
  FAIR_DAY_MY_EARNINGS: '/fairday/myEarnings',
  USER_PROFILE: '/userProfile',
  CALENDER: '/fsm/calendar',
  USER_CALENDER: '/fsm/calendar/userCalendar',
  SERVICE_FLOW: '/fsm/serviceFlow',
  SERVICE_FLOW_ASSIGN_TO_TL: '/fsm/serviceflow/assign-to-tl',
  SERVICE_FLOW_FACING_ISSUE: '/fsm/serviceFlow/facingIssue',
  SERVICE_FLOW_ADD_TASK: '/fsm/serviceflow/addTask',
  SERVICE_FLOW_RESCHEDULE: '/fsm/serviceflow/reschedule',
  SERVICE_FLOW_ASSIGN_REQUEST: '/fsm/serviceflow/assignrequest',
  SERVICE_FLOW_ASSIGN_REQUEST_SEARCH_AGENT:
    '/fsm/serviceflow/assignrequest/searchagent',
  MERCHANT_MAP: '/fsm/merchantMap',
  MERCHANT_MAP_INFO: '/fsm/merchantMap/info',
  MERCHANT_MAP_ASSIGN_FSE: '/fsm/merchantMap/assignFse',
  MERCHANT_MAP_EDIT_TASK: '/fsm/merchantMap/editTask',
  MERCHANT_MAP_VIEW_ZONE: '/fsm/merchantMapViewZone',
  MERCHANT_MAP_INFO_EDIT_ADDRESS: '/fsm/merchantMap/info/editAddress',
  MERCHANT_MAP_SEARCH: '/fsm/merchantMapSearch',
  TARGET: '/fsm/target',
  LANDING_PAGE: '/fsm/landingPage',
  GENERATE_OTP_PAGE: '/fsm/generateOtp',
  ATTENDANCE_RECORDS: '/fsm/attendanceRecords',
  MY_ZONE: '/fsm/myZone',
  VMN_MERCHANT_DETAIL: '/fsm/vmnMerchantDetail',
  EDC_PANEL: '/fsm/edcPanel',
  SUB_TEAM_TRACKING: '/fsm/subTeamTracking',
  GEO_HASH_SEARCH: '/fsm/geoHashSearch',
  PLOT_MERCHANT: '/fsm/plotMerchant',
  FILTER_PANEL: '/fsm/filterPanel',
  SEARCH_PANEL: '/fsm/searchPanel',
  TEAM_TRACKING: '/fsm/teamTracking',
  ZONE_TRACKING: '/fsm/zoneTracking',
  SELF_TRACKING: '/fsm/selfTracking',
  SEARCHED_TRACKING: '/fsm/searchedTracking',
  PROFILE: '/fsm/profile',
  REQUEST: '/fsm/request',
  ATTENDANCE: '/fsm/attendance',
  ATTENDANCE_HOLIDAY_CALENDER: '/fsm/attendance/holidayCalendar',
  ATTENDANCE_LEAVE_MANAGEMENT: '/fsm/attendance/leaveManagement',
  CREATE_NEW_GATE_MEETING: '/fsm/createNewGateMeeting',
  SERVICE_LIST: '/fsm/service/list',
  INITIAL_ROUTE: '/',
  EXIT_MANAGEMENT: '/fsm/exitManagement',
  EXIT_MANAGEMENT_INVENTORY_CTA_CLICKED: '/fsm/exitManagement/fse',
  INITIATE_RESIGNATION: '/fsm/initiateResignation',
  NO_INVENTORY: '/fsm/noInventoryInHand',
};

export const pathConstants = process.env.REACT_APP_V2
  ? Object.fromEntries(
      Object.entries(pathConstantKeys).map(([key, value]) => [
        key,
        `/v2${value}`,
      ]),
    )
  : pathConstantKeys;

export const externalAppActionConstants = {
  VIEW: 'android.intent.action.VIEW',
};

export const screenNameConstants = {
  MERCHANT_MAP: 'merchantMap',
  MY_TARGET: 'myTarget',
  TEAM_TARGET: 'teamTarget',
  ATTENDANCE_RECORDS: 'attendanceRecords',
  CALENDAR: 'calendar',
  USER: 'user',
  PSA: 'psa',
  MY_ZONE: 'myZone',
  USER_PROFILE: 'userProfile',
  MERCHANT_DETAIL: 'merchantDetail',
  EDC_PANEL: 'edcPanel',
  FAIR_DAY: 'fairday',
  FSM: 'fsm',
  CIF: 'cif',
  LANDING_PAGE: 'landingPage',
  EXIT_MANAGEMENT: 'exitManagement',
  AMS_EXIT_MANAGEMENT: 'amsExitManagement',
  INITIATE_RESIGNATION: 'initiateRegistration',
  TERMINATION_FORM: 'terminationFormScreen',
};

export const analyticsEventActionConstants = {
  TARGET_VIEW: 'target_view',
  TARGET_ACTIVE_VIEW: 'target_active_view',
  TARGET_LAST_MONTH_VIEW: 'target_lastmonth_view',
  TARGET_LAST_THREE_MONTH_VIEW: 'target_last3month_view',
  TARGET_LAST_SIX_MONTH_VIEW: 'target_last6month_view',
  TARGET_LAST_ONE_YEAR_VIEW: 'target_last1year_view',
  ACTIVITY_LAND: 'activity_land',
  TEAM_MAP_CLICK: 'teammap_click',
  PROFILE_CLICK: 'profile_click',
  PROFILE_LAND: 'profile_land',
  HOME_LAND: 'home_land',
  MERCHANT_SEARCH: 'merchant_search',
  MY_MERCHANT_SCREEN_TIME: 'mymerchants_screentime',
};
export const analyticsEventCategoryConstants = {
  FSM_MY_MERCHANTS: 'FSM my merchants',
  FSM_HOME: 'FSM home',
  FSM_AGENT_PROFILE: 'FSM agent profile',
  FSM_MY_TEAM: 'FSM my team',
  FSM_MY_TARGETS: 'FSM my targets',
  ATTENDANCE: 'Attendance',
};

export const pulseEventActionConstants = {
  ZOOM_OUT_CLICK: 'Zoom_out_clicked',
  ZOOM_IN_CLICK: 'Zoom_in_clicked',
  MERCHANT_PIN_CLICK: 'Merchant_pin_clicked',
  TRACK_CLICK: 'Track_Clicked',
  MY_TEAM_ZONE_CTA_CLICK: 'My_Team_Zones_CTA_clicked',
  MERCHANT_MAP_OPENED: 'Merchants_map_view_opened',
  ZONE_LIST_BTN_CLICK: 'Zone_List_button_clicked',
  TOP_SCREEN_FILTER_CLICK: 'Top_screen_filters_clicked',
  MERCHANT_PIN_INFO_CTA_CLICK: 'Merchant_pin_information_CTA_clicked',
  COMPETITOR_MERCHANT_CTA_CLICK: 'Competitor_merchants_CTA_clicked',
  MY_MERCHANT_TAB_CLICK: 'My_Merchants_tab_clicked',
  TEAM_MERCHANT_TAB_CLICK: 'Team_Merchants_tab_clicked',
  MERCHANT_CARD_SCROLL_THROUGH: 'Merchant_card_scrolled_through',
  MERCHANT_CARD_CLICK: 'Merchant_card_clicked',
  MERCHANT_CARD_VIEW_MORE_CTA_CLICK: 'Merchant_Card_View_More_CTA_Clicked',
  MERCHANT_CARD_CALL_CTA_CLICK: 'Merchant_Card_Calling_CTA_clicked',
  MERCHANT_DETAIL_CTA_CLICK: 'Merchant_Details_Merchant_Details_CTA_Clicked',
  MERCHANT_DETAIL_CALL_CTA_CLICK: 'Merchant_Details_Calling_CTA_clicked',
  MERCHANT_DETAIL_DIRECTION_CTA_CLICK:
    'Merchant_Details_Directions_CTA_clicked',
  MERCHANT_DETAIL_MERCHANT_PHOTO_CLICK:
    'Merchant_Details_Merchant_photo_clicked',
  MERCHANT_DETAIL_TAG_CLICKED: 'Merchant_Details_Tag_Clicked',
  MERCHANT_CARD_DIRECTION_CTA_CLICK: 'Merchant_Card_Directions_CTA_clicked',
  MERCHANT_CARD_FILTER_OPENED: 'Merchant_card_Filters_opened',
  MERCHANT_CARD_FILTER_CATEGORY_SELECTED:
    'Merchant_card_Filter_Category_selected',
  MERCHANT_CARD_FILTER_VALUES_SELECTED: 'Merchant_card_Filter_values_ticked',
  MERCHANT_CARD_FILTER_VALUES_UNSELECTED:
    'Merchant_card_Filter_values_unticked',
  MERCHANT_CARD_TAG_CLICKED: 'Merchant_Card_Tag_Clicked',
  ZONE_FILTER_CATEGORY_SELECTED: 'Zone_Filter_Category_selected',
  ZONE_FILTER_VALUE_SELECTED: 'Zone_Filter_values_ticked',
  ZONE_FILTER_VALUE_UNSELECTED: 'Zone_Filter_values_unticked',
  ATTENDANCE_CHECKIN_SCAN_ERROR: 'Attendance_Checkin_Scan_Error',
  AGENT_UNASSIGN_BTN_CLICK: 'Agent_unassign_button_clicked',
  AGENT_TEAM_TAB_CLICK: 'Agent_team_tab_clicked',
  AGENT_UNASSIGN_CANCELLED: 'Agent_unassign_cancelled',
  REVISIT_BTN_CLICK: 'Revisit_button_clicked',
  GET_DIRECTION: 'Get_Direction',
  MERCHANT_DETAIL_CLICK: 'Merchant_Details_Click',
  OUT_ZONE_CLICK: 'Out_of_Zone_Clicked',
  FACING_ISSUE: 'Facing_Issues',
  ADDING_TASK: 'Adding_Task',
  RESCHEDULE_CLICK: 'Reschedule_Click',
  MERCHANT_PIN_EXPENSION_CLICK: 'Merchant_pins_expansion_clicked',
  MERCHANT_TAG_EXPENSION_CLICK: 'Merchant_tags_expansion_clicked',
  SHOW_ON_MAP_CLICK: 'Show_on_map_clicked',
  SERVICE_TAG_CLICK: 'Service_tag_clicked',
  SERVICE_AGING_SCREEN_OPEN: 'Service_aging_screen_opens',
  ATTENDANCE_CHECKIN_CAMERA_OPENED: 'Attendance_Checkin_Camera_Opened',
  ATTENDANCE_CHECKIN_SCAN_LOCATION_OFF: 'Attendance_Checkin_Scan_Location_Off',
  ZONE_LIST_VIEW_OPENS: 'Zone_List_view_opens',
  SELECT_ALL_CLICK: 'Select_All_Clicks',
  ATTENDANCE_CHECKIN_SUCCESSFUL: 'Attendance_Checkin_Successful',
  ATTENDANCE_CHECKOUT_SUCCESSFUL: 'Attendance_Checkout_Successful',
  GATE_MEETING_CHECKIN_FAIL: 'gate_meeting_checkin_fail',
  MAP_VIEW_CLICK: 'Map_View_Click',
  STATUS_TAGS_CLICK: 'Status_Tags_Click',
  LONG_PRESS_BEATS: 'Long_Press_Beats',
  ASSIGN_REQUEST_CLICK: 'Assign_Request_Click',
  SELECT_ICON_CLICKED: 'Select_Icon_Clicked',
  ASSIGN_TO_ME_CLICK: 'Assign_To_Me_Click',
  TOP_FILTER_CLICK: 'Top_Filter_Click',
  TOP_SEARCH_CLICK: 'Top_Search_Click',
  AGENT_NAME_CLICK: 'Click_on_Agent_Name',
  CONFIRM_NO: 'Confirmation_No',
  CONFIRM_YES: 'Confirmation_Yes',
  SORT_ON_CLICK: 'Click_on_Sort',
  PLUS_ON_CLICK: 'Click_on_Plus',
  SORT_BY_DISTANCE: 'Sort_by_Distance',
  SORT_BY_ACTIVE_REQUEST: 'Sort_by_Active_Requests',
  CLICK_ON_CALL: 'Click_on_Call',
  ATTENDANCE_EMP_DETAIL_OPENED: 'Attendance_Employee_Detail_List_View_Opened',
  MY_ATTENDANCE_DETAIL_OPENED: 'My_Attendance_List_View_Opened',
  VIEW_LOCATION_HISTORY_CLICK: 'View_Location_History_Clicked',
  MY_TEAM_BOTTOM_DRAWER_CLICK: 'My_Team_Bottom_Drawer_Clicked',
  AGENT_ADD_CANCELLED: 'Agent_addition_cancelled',
  AGENT_ADD_BTN_CLICK: 'Add_Agent_button_clicked',
  AGENT_ADD_BTN_CONFIRM: 'Agent_addition_confirmed',
  AGENT_UNASSIGN_CONFIRM: 'Agent_unassign_confirmed',
  AGENT_ADDTION_BTN_CLICK: 'Agent_addition_button_clicked',
  LIST_VIEW_CLICK: 'List_View_Click',
  PIN_CLICK: 'Pin_Click',
  LONG_PRESS_GEOHASH: 'Long_Press_Geohash',
  MERCHANT_ZOOM_IN: 'Merchant_Zoom_In',
  MERCHANT_ZOOM_OUT: 'Merchant_Zoom_Out',
  ATTENDANCE_EMP_DETAIL_CALENDER_VIEW_OPENED:
    'Attendance_Employee_Detail_Calendar_View_Opened',
  ATTENDANCE_EMP_LIST_VIEW_OPENED: 'Attendance_Employee_List_View_Opened',
  MY_ATTENDANCE_CALENDER_VIEW_OPENED: 'My_Attendance_Calendar_View_Opened',
  MY_ZONE_CLICK: 'My_Zones_Clicked',
  MY_MERCHANTS_CLICK: 'My_Merchants_Clicked',
  MY_TEAM_CLICK: 'My_Team_Clicked',
  ATTENDANCE_CLICKED: 'Attendance_Clicked',
  ATTENDANCE_EMP_REQUEST_VIEW_OPENED: 'Attendance_Employee_Request_View_Opened',
  MY_TEAM_SMART_FILTER: 'My_Team_Smart_Filter',
  VIEW_EDIT_ASSIGNMENT_BTN_CLICK: 'View/edit_assignment_button_clicked',
  MY_TEAM_ZONE_VIEW_OPEN: 'My_Team_Zones_view_opened',
  MY_ZONE_VIEW_OPEN: 'My_Zones_view_opened',
  ZONE_CLICK_MULTI_SELECT: 'Zone_Clicked_Multiselect_View',
  ZONE_CLICK: 'Zone_Clicked',
  ZONE_DETAIL_COVER_FROM_BOTTOM_OPEN: 'Zone_Details_cover_from_bottom_opened',
  ZONE_ASSIGNMENT_DONE_CLICK: 'Zone_Assignment_Done_Clicked',
  MULTI_SELECT_CTA_CLICK: 'Multi_Select_CTA_clicked',
  CLICK_ON_SEARCH: 'Click_on_Search',
  CLICK_ON_BACK: 'Click_on_Back',
  FILTER_BUTTON_CLICKED: 'Filter_Button_Clicked',
  MY_TEAM_LIST_VIEW_CLICKED: 'My_Team_List_View_Clicked',
  MY_TEAM_MAP_VIEW_CLICKED: 'My_Team_Map_View_Clicked',
  MY_ZONES_CTA_CLICKED: 'My_Zones_CTA_Clicked',
  TL_VIEW_CLICKED: 'TL_View_Clicked',
  CROSS_CLICKED: 'Cross_Clicked',
  CLOSED_REQUEST_CLICKED: 'Closed_Request_Clicked',
  ALPHABETICAL_ORDER_CLICKED: 'Alphabetical_Order_Clicked',
  TOTAL_REQUEST_CLICKED: 'Total_Request_Clicked',
  SEARCH_BUTTON_CLICKED: 'Search_Button_Clicked',
  ASSIGN_PLUS_CLICKED: 'Assign_Plus_Clicked',
  CALL_BUTTON_CLICKED: 'Call_Button_Clicked',
  VIEW_INVENTORY_RECOVERY_DETAILS_CTA_CLICKED:
    'VIEW_INVENTORY_RECOVERY_DETAILS_CTA_CLICKED',
  ASSIGN_TO_ANOTHER_TL: 'Assign_to_Another_TL',
  CALL_OPTION_CLICKED: 'Call_Option_Clicked',
  VISITING_CARD_SHARE_BUTTON: 'Click share button of visting card',
  AUTHORIZATION_LETTER: 'Click Show Authorisation Letter',
  VISITING_CARD_EDIT_PHOTO_BUTTON: 'Click Edit Photo Button',
  VISITING_CARD_CONFIRM_PHOTO_BUTTON: 'Click Confirm Photo Button',
  REPORTING_MANAGER_DETAILS: 'Click Call Reporting Manager Button',
  SCREEN_TIME_RECORD: 'Screen_Time_Record',
  FSM_START_MEETING: 'FSM_Start_Meeting',
  FSM_END_MEETING: 'FSM_End_Meeting',
  FSM_START_MEETING_OKAY_GOT_IT: 'FSM_Start_Meeting_Okay_got_it',
  FSM_START_MEETING_TITLE_GATE_MEETING: 'FSM_Start_Meeting_Title_Gate_Meeting',
  FSM_SUBMIT_AND_END_MEETING: 'FSM_Submit_&_End Meeting',
  FSM_JOIN_MEETING: 'FSM_Join_Meeting',
  FSM_CONFIRM: 'FSM_confirm',
  FSM_FSE_CHECKIN_NO_ACTIVE_MEETING: 'FSM_FSE_CHECKIN_NO_ACTIVE_MEETING',
  FSM_FSE_ALREADY_CHECKED_IN: 'FSM_FSE_ALREADY_CHECKED_IN',
  FSM_FSE_OUT_OF_ZONE_CHECKIN: 'FSM_FSE_OUT_OF_ZONE_CHECKIN',
  FSM_TL_OUT_OF_ZONE_MEETING_START: 'FSM_TL_OUT_OF_ZONE_MEETING_START',
  FSM_USER_NOT_TL_MEETING_START: 'FSM_USER_NOT_TL_MEETING_START',
  FSM_TL_MEETING_ALREADY_STARTED: 'FSM_TL_MEETING_ALREADY_STARTED',
  FSM_TL_MEETING_ALREADY_ENDED: 'FSM_TL_MEETING_ALREADY_ENDED',
  FSM_TL_IMAGE_ALREADY_UPLOADED: 'FSM_TL_IMAGE_ALREADY_UPLOADED',
  FSM_TL_IMAGE_CLICKED_OUT_OF_ZONE: 'FSM_TL_IMAGE_CLICKED_OUT_OF_ZONE',
  FSM_TL_IMAGE_NOT_CLICKED_WHEN_MEETING_END:
    'FSM_TL_IMAGE_NOT_CLICKED_WHEN_MEETING_END',
  FSM_LOCATION_FETCH_INACCURATE: 'FSM_LOCATION_FETCH_INACCURATE',
  FSM_GATE_MEETING_CHECKIN_SUCCESSFUL: 'FSM_GATE_MEETING_CHECKIN_SUCCESSFUL',
  FSM_GATE_MEETING_START_SUCCESS: 'FSM_GATE_MEETING_START_SUCCESS',
  FSM_GATE_MEETING_IMAGE_UPLOAD_SUCCESS:
    'FSM_GATE_MEETING_IMAGE_UPLOAD_SUCCESS',
  FSM_GATE_MEETING_END_SUCCESS: 'FSM_GATE_MEETING_END_SUCCESS',
  PIMARY_NUMBER_ARROW_CLICK: 'Primary_Number_Arrow_Click',
  SECONDARY_NUMBER_ARROW_CLICK: 'Secondary_Number_Arrow_Click',
  SENDBIRD_ARROW_CLICK: 'Sendbird_Arrow_Click',
  CALL_BUTTON_CLICK: 'Call_Button_Click',
  BOSS_NUMBER_ARROW_CLICK: 'Boss_Number_Arrow_Click',
  VIEW_DETAILS_CLICKED: 'View_Details_Clicked',
  EXIT_MANAGEMENT_PAGE_LOADED: 'Exit_Management_Page_Loaded',
  INITIATE_RESIGNATION_PAGE_LOADED: 'Initiate_Resignation_Page_Loaded',
  RESIGNATION_SUBMITTED_PAGE_LOADED: 'Resignation_Submitted_Page_Loaded',
  CONFIRM_AND_PROCEED_TO_RESIGN_CLICKED:
    'Confirm_And_Proceed_To_Resign_Clicked',
  TAG_CLCIKED: 'Tag_Clicked',
  VIEW_INVENTORY_RECOVERY_DETAILS_CLICKED:
    'View_Inventory_Recovery_Details_Clicked',
  EXIT_DETAILS_API_SUCCESS: 'EXIT_DETAILS_API_SUCCESS',
  EXIT_DETAILS_API_FAILURE: 'EXIT_DETAILS_API_FAILURE',
  EXIT_DETAILS_API_WITH_PARAMS_SUCCESS: 'EXIT_DETAILS_API_WITH_PARAMS_SUCCESS',
  EXIT_DETAILS_API_WITH_PARAMS_FAILURE: 'EXIT_DETAILS_API_WITH_PARAMS_FAILURE',
  RESIGN_SUCCESSFUL: 'RESIGN_SUCCESS',
  SEPARATION_REASONS_SUCCESS: 'SEPARATION_REASONS_SUCCESS',
  SEPARATION_REASONS_FAILURE: 'SEPARATION_REASONS_FAILURE',
  PENDING_DUES_SUCCESS: 'PENDING_DUES_SUCCESS',
  PENDING_DUES_FAILURE: 'PENDING_DUES_FAILURE',
  HIERARCHY_SUCCESS: 'HIERARCHY_SUCCESS',
  HIERARCHY_NOT_VALID_TYPE: 'INVALID_TYPE',
  HIERARCHY_OFFSET_NULL: 'OFFSET_NULL',
  HIERARCHY_LIMIT_NULL: 'LIMIT_NULL',
  HIERARCHY_PROFILE_DO_NOT_EXIST: 'USER_PROFILE_DOES_NOT_EXIST',
  RESIGN_API_WRONG_RESIGNATION_DATE_FORMAT:
    'RESIGN_API_WRONG_RESIGNATION_DATE_FORMAT',
  RESIGN_API_LAST_WORKING_DATE_ISSUE: 'RESIGN_API_LAST_WORKING_DATE_ISSUE',
  RESIGN_API_EXIT_REASON_MISSING: 'RESIGN_API_EXIT_REASON_MISSING',
  RESIGN_API_EXIT_REQUEST_CANNOT_RAISE_FOR_OTHERS:
    'RESIGN_API_EXIT_REQUEST_CANNOT_RAISE_FOR_OTHERS',
  RESIGN_API_EXIT_REQUEST_ALREADY_EXIST:
    'RESIGN_API_EXIT_REQUEST_ALREADY_EXIST',
  TEAM_SEPARATION_INITIATED: 'TEAM_SEPARATION_INITIATED',
};
export const pulseEventCategoryConstants = {
  MY_MERCHANTS: 'My_Merchants',
  TEAM_MERCHANTS: 'Team_Merchants',
  MY_TEAM_MERCHANTS: 'My_Team_Merchants',
  MY_TEAM: 'My_Team',
  MY_TEAM_ZONE: 'My_Team_Zones',
  MY_ZONE: 'My_Zones',
  MY_MERCHANT_ZONE_LIST: 'My_Merchants_Zone_List',
  ATTENDANCE: 'Attendance',
  GATE_MEETING_CHECKIN: 'gate_meeting_check_in',
  MERCHANT_NAME_ARROW: 'Merchant_Name_Arrow',
  MY_TEAM_MAP: 'My_Team_Map',
  MY_TEAM_MAP_LH: 'My_Team_Map_LH',
  MY_MERCHANT_LIST_VIEW: 'My_Merchants_ListView',
  MY_MERCHANT_PIN_CLICK: 'My_Merchants_PinClick',
  TEAM_MERCHANT_LIST_VIEW: 'Team_Merchants_ListView',
  TEAM_MERCHANT_LIST_VIEW_LONG_PRESS: 'Team_Merchants_ListView_LongPress',
  ASSIGN_REQUEST: 'Assign_Requests',
  ASSIGN_REQUEST_SORT: 'Assign_Requests_Sort',
  ASSIGN_REQUEST_CONF: 'Assign_Requests_Conf',
  FSM_HOME: 'FSM_Home',
  MY_TEAM_MAP_TL_DETAILS: 'My_Team_Map_TLDetails',
  MY_TEAM_MAP_TL_DETAILS_ASSIGN_TL: 'My_Team_Map_TLDetails_AssignTL',
  MY_TEAM_MAP_TL_DETAILS_ASSIGN_TL_SORT: 'My_Team_Map_TLDetails_AssignTL_Sort',
  MY_TEAM_MAP_LH_BC: 'My_Team_Map_LH_BC',
  SHAREABLE_VISITING_CARD: 'FSE_Profile_PersonalDetails',
  TEAM_MERCHANTS_PIN_CLICK: 'Team_Merchants_PinClick',
  FSM_GATE_MEETING_TL: 'FSM_Gate_Meeting_TL',
  FSM_GATE_MEETING_FSE: 'FSM_Gate_Meeting_FSE',
  CALL_FROM_PRIMARY_NUMBER_SB_ENABLED_CT_ENABLED:
    'CALL_FROM_PRIMARY_NUMBER_SB_ENABLED_CT_ENABLED',
  CALL_FROM_SECONDARY_NUMBER_SB_ENABLED_CT_ENABLED:
    'CALL_FROM_SECONDARY_NUMBER_SB_ENABLED_CT_ENABLED',
  CALL_FROM_PRIMARY_NUMBER_SB_ENABLED_CT_DISABLED:
    'CALL_FROM_PRIMARY_NUMBER_SB_ENABLED_CT_DISABLED',
  CALL_FROM_SECONDARY_NUMBER_SB_ENABLED_CT_DISABLED:
    'CALL_FROM_SECONDARY_NUMBER_SB_ENABLED_CT_DISABLED',
  CALL_FROM_PRIMARY_NUMBER_SB_DISABLED_CT_ENABLED:
    'CALL_FROM_PRIMARY_NUMBER_SB_DISABLED_CT_ENABLED',
  CALL_FROM_SECONDARY_NUMBER_SB_DISABLED_CT_ENABLED:
    'CALL_FROM_SECONDARY_NUMBER_SB_DISABLED_CT_ENABLED',
  CALL_FROM_PRIMARY_NUMBER_SB_DISABLED_CT_DISABLED:
    'CALL_FROM_PRIMARY_NUMBER_SB_DISABLED_CT_DISABLED',
  CALL_FROM_SECONDARY_NUMBER_SB_DISABLED_CT_DISABLED:
    'CALL_FROM_SECONDARY_NUMBER_SB_DISABLED_CT_DISABLED',
  CALL_FROM_SB_ENABLED: 'CALL_FROM_SB_ENABLED',
  CALL_FROM_SINGLE_NUMBER_PRESENT_SB_DISABLED_CT_ENABLED:
    'CALL_FROM_SINGLE_NUMBER_PRESENT_SB_DISABLED_CT_ENABLED',
  CALL_FROM_SINGLE_NUMBER_PRESENT_SB_DISABLED_CT_DISABLED:
    'CALL_FROM_SINGLE_NUMBER_PRESENT_SB_DISABLED_CT_DISABLED',
  CALL_FROM_BOSS_NUMBER_SB_DISABLED_CT_ENABLED:
    'CALL_FROM_BOSS_NUMBER_SB_DISABLED_CT_ENABLED',
  CALL_FROM_BOSS_NUMBER_SB_DISABLED_CT_DISABLED:
    'CALL_FROM_BOSS_NUMBER_SB_DISABLED_CT_DISABLED',
  CALL_FROM_BOSS_NUMBER_SB_ENABLED_CT_ENABLED:
    'CALL_FROM_BOSS_NUMBER_SB_ENABLED_CT_ENABLED',
  CALL_FROM_BOSS_NUMBER_SB_ENABLED_CT_DISABLED:
    'CALL_FROM_BOSS_NUMBER_SB_ENABLED_CT_DISABLED',
  EXIT_MANAGEMENT_TL: 'EXIT_MANAGEMENT_TL',
  EXIT_MANAGEMENT_FSE: 'EXIT_MANAGEMENT_FSE',
  EXIT_MANAGEMENT_ASM: 'EXIT_MANAGEMENT_ASM',
};

export const gateMeetingConstants = {
  CAM_BACK_TRIP: true,
  CAM_CONFIRM_TITLE: 'Confirm Photo',
  CAM_SCREEN_TITLE: 'Take Photo',
  FEEDBACK_FORM: 'FEEDBACK_FORM',
  GALLERY_UPLOAD_OPTION: false,
  GATE_MEETING: 'GROUP_MEETING',
};

export const mapTypeConstants = {
  MMI: 'mapMyIndia',
};
export default FSMCONSTANTS;

export const zoneFilterConstants = {
  UNASSIGNED_FSE: 'UNASSIGNED_FSE',
  ASSIGNED_FSE: 'ASSIGNED_FSE',
  UNASSIGNED_ZONE: 'UNASSIGNED_ZONE',
};

/* 
  stopReloadUrlList: 
  In case we get an error screen (GenericErrorScreen) and on click of Retry CTA 
  we don't want to make API calls in that particular page then we can add a 
  constant (ex: FSMCONSTANTS.GENERATE_OTP_PAGE) of that particular page in this list. 
  In addition to this an isReload search param should be used in the respective 
  component as a check for blocking API calls or for any other purpose.  
 */
export const stopReloadUrlList = [FSMCONSTANTS.GENERATE_OTP_PAGE];
